<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 21V8h16v13" />
    <path d="M10 21v-5h4v5" />
  </svg>
</template>

<script lang="ts">
export default {
  name: "IconBuildingStorefront",
  props: ["height", "width"],
}
</script>
